var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.727 2a.91.91 0 1 0 0 1.818h4.148L8.364 14.33a.924.924 0 0 0 1.306 1.306L20.182 5.125v4.148a.91.91 0 1 0 1.818 0V3a1 1 0 0 0-1-1zM3 5.636a1 1 0 0 0-1 1V21a1 1 0 0 0 1 1h14.364a1 1 0 0 0 1-1v-8.623c0-.81-.98-1.216-1.552-.643a.9.9 0 0 0-.267.643v6.805a1 1 0 0 1-1 1H4.819a1 1 0 0 1-1-1V8.455a1 1 0 0 1 1-1h6.805a.9.9 0 0 0 .643-.267c.573-.572.167-1.552-.643-1.552z"
})));
export default SvgExternal;